import '@ui5/webcomponents/dist/Link.js';
import { LinkDesign } from '../../enums';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `Link` is a hyperlink component that is used to navigate to other apps and web pages, or to trigger actions. It is a clickable text element, visualized in such a way that it stands out from the standard text. On hover, it changes its style to an underlined text to provide additional feedback to the user.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/Link" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const Link = withWebComponent('ui5-link', ['accessibleName', 'accessibleNameRef', 'design', 'href', 'target', 'wrappingType'], ['disabled'], [], ['click']);
Link.displayName = 'Link';
Link.defaultProps = {
    design: LinkDesign.Default
};
export { Link };
